import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieOffer = {
  id: string
  name: string
  payment_type: string
  price_cents: number | null
  billing_interval: 'month' | 'year' | null
  installment_count: number | null
  page_url: string
}

export function useObieOffers(params: {
  client: Client
  event: ObvioEvent
  obieHubId: string
}) {
  const {client, event, obieHubId} = params

  return useQuery<ObieOffer[], {message: string}>({
    queryKey: ['events', event.id, 'integrations', 'obie', 'offers', obieHubId],
    queryFn: () =>
      client.get<ObieOffer[]>(
        api(
          `/events/${event.id}/integrations/obie/offers?obie_hub_id=${obieHubId}`,
        ),
      ),
  })
}
